var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"number-text",class:_vm.isMobile ? 'number-text-mobile' : ''},[_vm._v(_vm._s(_vm.renderValue))]),_c('div',{staticClass:"progress-bar",class:_vm.getValueClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }